// @ts-nocheck
import { TrackPurchaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPurchase";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";

const mapPurchaseItems = (
    parameters: Partial<TrackPurchaseParameters>,
    options?: Toolkit.GoogleAnalytics.Options,
    eventListParameters?: Partial<TrackPurchaseParameters>,
): TrackPurchaseParameters["items"] => {
    if (parameters.items) {
        return parameters.items;
    }

    if (!options?.cart?.cartLines) {
        return parameters.items;
    }

    return ga.map.manyItems(
        options.cart.cartLines,
        (cartLine, mapOptions) => ({
            ...ga.map.cartLineModel(cartLine, mapOptions),
            is_sample: Boolean(cartLine.properties?.sampleItemNumber),
        }),
        {
            ...options,
            itemData: {
                currency: parameters.currency ?? eventListParameters?.currency,
                item_list_id: parameters.item_list_id ?? eventListParameters?.item_list_id,
                item_list_name: parameters.item_list_name ?? eventListParameters?.item_list_name,
                ...options.itemData,
            },
        },
    );
};

export default mapPurchaseItems;
